import React from "react";
import { Section } from "../../layout/Section";
import { useT } from "../../hooks/useT";
import { DynamicPage } from "../../layout/DynamicPage";

export const E404 = () => {
  const { t } = useT();
  return (
    <DynamicPage>
      <Section title={t("page.404.title")}>
        <p>{t("page.404.body")}</p>
      </Section>
    </DynamicPage>
  );
};
